import type { AppConfig } from '@/shared/config/app-config-schema'

// Names, hosts, keys and assets of the leaply build (APP_CONFIG=leaply).
export const appConfig = {
  name: 'Leaply',
  siteUrl: 'https://theleaply.com',
  apiUrl: 'https://api.theleaply.com',
  cdnUrl: 'https://cdn.theleaply.com',
  supportApiUrl: 'https://support-api.theleaply.com',
  supportEmail: 'support@theleaply.com',
  // Subjects the support desk routes tickets by
  supportTicketSubjects: {
    default: 'LEAPLY_WEB_APP',
    cancellationFlow: 'LEAPLY_CANCELLATION_FLOW',
    billingHistory: 'LEAPLY_BILLING_HISTORY',
  },
  // Window globals of the support widget's embed.js
  supportGlobals: {
    config: 'LeaplySupportConfig',
    widget: 'LeaplySupport',
  },
  // Read by the site to detect a session here, so both sides must agree on it.
  // Prefix of every localStorage key; changing it on a live deployment signs everyone out.
  storagePrefix: 'leaply',
  sessionCookie: {
    name: 'leaply_is_logged_in',
    domain: '.theleaply.com',
  },
  amplitudeApiKey: '358590d5b7ce9a7c1dfcc94acbf39bd2',
  sentry: {
    org: 'theleaply',
    project: 'web',
  },
  assets: {
    favicon: '/favicon.svg',
    logo: '/images/login-logo.webp',
    logoFull: '/images/logo-full.svg',
    logoIcon: '/images/logo-icon.svg',
    appIcon: '/images/AppIcon.svg',
    collectionEmptyCards: '/images/profile/collection-empty-cards.webp',
    // Plan illustrations drawn in the theme palette
    onboarding: {
      facts: {
        vgn: [
          '/images/onboarding/icons/vgn-fact1.svg',
          '/images/onboarding/icons/vgn-fact2.svg',
          '/images/onboarding/icons/vgn-fact3.svg',
        ],
        lmp: [
          '/images/onboarding/icons/lmp-fact1.svg',
          '/images/onboarding/icons/lmp-fact2.svg',
          '/images/onboarding/icons/lmp-fact3.svg',
        ],
        kds: [
          '/images/onboarding/icons/kds-fact1.svg',
          '/images/onboarding/icons/kds-fact2.svg',
          '/images/onboarding/icons/kds-fact3.svg',
        ],
        posture: [
          '/images/onboarding/icons/posture-fact1.svg',
          '/images/onboarding/icons/posture-fact2.svg',
          '/images/onboarding/icons/posture-fact3.svg',
        ],
      },
      lymphFigure: '/images/onboarding/icons/lymph-dude.svg',
      journeyPreparing: '/images/onboarding/journey-preparing.svg',
    },
    // Collection tier sounds under /sounds, keyed by the event name the shared module emits
    collectionSounds: {
      UNLOCK: 'unlock.mp3',
      BRONZE: 'bronze.mp3',
      SILVER: 'silver.mp3',
      GOLD: 'gold.mp3',
      DIAMOND: 'diamond.mp3',
      BRONZE_2: 'bronze_2.mp3',
      SILVER_2: 'silver_2.mp3',
      GOLD_2: 'gold_2.mp3',
      DIAMOND_2: 'diamond_2.mp3',
    },
  },
  appLinks: {
    oneLink: 'https://leaply.onelink.me/79lP/q77720k6',
    appStore: 'https://apps.apple.com/app/id6748984493',
    googlePlay:
      'https://play.google.com/store/apps/details?id=com.leaply.android',
  },
} satisfies AppConfig
